import React from 'react'
import { Code, Link } from './shared-styled-components'

export const LinkRenderer = (props: { children: React.ReactNode }) => {
  return <Link>{props.children}</Link>
}

export const CodeRenderer = (props: { children: React.ReactNode }) => {
  return <Code>{props.children}</Code>
}
